module.exports = __webpack_public_path__ + "media/intro-v4.00245cf7.mp4";